import { render, staticRenderFns } from "./DepositTypeAllocation.vue?vue&type=template&id=6d1a4e7c&scoped=true"
import script from "./DepositTypeAllocation.vue?vue&type=script&lang=js"
export * from "./DepositTypeAllocation.vue?vue&type=script&lang=js"
import style0 from "./DepositTypeAllocation.vue?vue&type=style&index=0&id=6d1a4e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1a4e7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLazy,VRow})
